/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JurisdictionBlockReason } from './JurisdictionBlockReason';
import {
    JurisdictionBlockReasonFromJSON,
    JurisdictionBlockReasonFromJSONTyped,
    JurisdictionBlockReasonToJSON,
    JurisdictionBlockReasonToJSONTyped,
} from './JurisdictionBlockReason';

/**
 * 
 * @export
 * @interface PaidEntryEligibilityResponse
 */
export interface PaidEntryEligibilityResponse {
    /**
     * True when this viewer may enter paid competitions from their current location. A board may still refuse on its own terms (prize caps) — see the per-competition eligibility route.
     * @type {boolean}
     * @memberof PaidEntryEligibilityResponse
     */
    allowed: boolean;
    /**
     * Stable id of the failure. Live values: `jurisdictionContest` (paid entry is not available from this location), `minimumAge` (the viewer is known to be under the platform minimum). A missing date of birth never appears here — it does not block at viewer level. Only present when allowed=false.
     * @type {string}
     * @memberof PaidEntryEligibilityResponse
     */
    failedCheck?: string;
    /**
     * Operator-readable failure reason. Only present when allowed=false.
     * @type {string}
     * @memberof PaidEntryEligibilityResponse
     */
    reason?: string;
    /**
     * 
     * @type {JurisdictionBlockReason}
     * @memberof PaidEntryEligibilityResponse
     */
    blockReason?: JurisdictionBlockReason;
    /**
     * ISO 3166-1 alpha-2 code the decision was made against, when a location was resolved.
     * @type {string}
     * @memberof PaidEntryEligibilityResponse
     */
    country?: string;
    /**
     * Sub-national code, unqualified (e.g. "LA"), when the provider resolved one.
     * @type {string}
     * @memberof PaidEntryEligibilityResponse
     */
    region?: string;
    /**
     * Human-readable region name for player-facing copy (e.g. "Louisiana"). Absent when the provider did not supply one; clients fall back to the code.
     * @type {string}
     * @memberof PaidEntryEligibilityResponse
     */
    regionName?: string;
}



/**
 * Check if a given object implements the PaidEntryEligibilityResponse interface.
 */
export function instanceOfPaidEntryEligibilityResponse(value: object): value is PaidEntryEligibilityResponse {
    if (!('allowed' in value) || value['allowed'] === undefined) return false;
    return true;
}

export function PaidEntryEligibilityResponseFromJSON(json: any): PaidEntryEligibilityResponse {
    return PaidEntryEligibilityResponseFromJSONTyped(json, false);
}

export function PaidEntryEligibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaidEntryEligibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed': json['allowed'],
        'failedCheck': json['failedCheck'] == null ? undefined : json['failedCheck'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'blockReason': json['blockReason'] == null ? undefined : JurisdictionBlockReasonFromJSON(json['blockReason']),
        'country': json['country'] == null ? undefined : json['country'],
        'region': json['region'] == null ? undefined : json['region'],
        'regionName': json['regionName'] == null ? undefined : json['regionName'],
    };
}

export function PaidEntryEligibilityResponseToJSON(json: any): PaidEntryEligibilityResponse {
    return PaidEntryEligibilityResponseToJSONTyped(json, false);
}

export function PaidEntryEligibilityResponseToJSONTyped(value?: PaidEntryEligibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed': value['allowed'],
        'failedCheck': value['failedCheck'],
        'reason': value['reason'],
        'blockReason': JurisdictionBlockReasonToJSON(value['blockReason']),
        'country': value['country'],
        'region': value['region'],
        'regionName': value['regionName'],
    };
}

